export { LiquidGlassView, isLiquidGlassSupported } from "@callstack/liquid-glass";
